// extracted by mini-css-extract-plugin
module.exports = {"bold":"Profile_bold__2KIdP","frameset":"Profile_frameset__2wFBA"};